import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export interface EmpresaSociosEnqueueResponse {
  requestId?: string;
  totalEmpresas?: number;
  empresaIds?: number[];
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class EmpresaSocioService {

  readonly serviceApi = environment.apiUrl;

  constructor(private readonly http: HttpClient) { }

  /** Uma empresa, várias (empresaIds) ou todas (sem parâmetros / body vazio). Códigos = CodDominio. */
  requestEmpresaSocio(empresaId?: number | null, empresaIds?: number[] | null) {
    if (empresaIds?.length) {
      return this.http.post<EmpresaSociosEnqueueResponse>(
        `${this.serviceApi}/v1/dominio-reports/empresa/socios`,
        { empresaIds: empresaIds.filter((id) => id > 0) }
      );
    }

    if (empresaId != null && empresaId > 0) {
      return this.http.post<EmpresaSociosEnqueueResponse>(
        `${this.serviceApi}/v1/dominio-reports/empresa/socios`,
        { empresaId }
      );
    }

    return this.http.post<EmpresaSociosEnqueueResponse>(
      `${this.serviceApi}/v1/dominio-reports/empresa/socios`,
      {}
    );
  }

  /** Várias empresas via planilha (POST multipart). */
  requestEmpresaSocioPorPlanilha(planilha: File) {
    const formData = new FormData();
    formData.append('planilha', planilha);
    return this.http.post(`${this.serviceApi}/v1/dominio-reports/empresa/socios/planilha`, formData);
  }
}
